import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Image, Ticket, ShoppingBag, MessageSquare, LogOut, Percent, Settings, FileText, CreditCard, ListOrdered } from 'lucide-react';

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('adminAuth');
    navigate('/admin');
  };

  const menuItems = [
    { path: '/admin/dashboard', label: 'Dashboard', icon: LayoutDashboard },
    { path: '/admin/templates', label: 'Templates', icon: Image },
    { path: '/admin/subscription-plans', label: 'Plans', icon: CreditCard },
    { path: '/admin/coupons', label: 'Coupons', icon: Ticket },
    { path: '/admin/affiliate-coupons', label: 'Affiliates', icon: Percent },
    { path: '/admin/orders', label: 'Orders', icon: ShoppingBag },
    { path: '/admin/messages', label: 'Messages', icon: MessageSquare },
    { path: '/admin/redemption-instructions', label: 'Redemption', icon: ListOrdered },
    { path: '/admin/site-content', label: 'Site Content', icon: FileText },
    { path: '/admin/settings', label: 'Settings', icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-md">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="https://customer-assets.emergentagent.com/job_giftcard-vault-1/artifacts/03yh11a7_MethodMate%20Main%20Logo%20%281%29.png" 
                alt="MethodMate" 
                className="h-12"
              />
              <span className="ml-4 text-xl font-bold text-gray-700">Admin Panel</span>
            </div>
            <button
              onClick={handleLogout}
              className="flex items-center space-x-2 px-4 py-2 text-gray-700 hover:text-[#1E88E5] transition-colors"
              data-testid="admin-logout-btn"
            >
              <LogOut className="w-5 h-5" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid lg:grid-cols-5 gap-8">
          {/* Sidebar */}
          <div className="lg:col-span-1">
            <nav className="bg-white rounded-lg shadow-md p-4 space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                return (
                  <button
                    key={item.path}
                    onClick={() => navigate(item.path)}
                    className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-colors ${
                      isActive
                        ? 'bg-[#1E88E5] text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    }`}
                    data-testid={`admin-nav-${item.label.toLowerCase()}`}
                  >
                    <Icon className="w-5 h-5" />
                    <span className="font-medium">{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-4">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
